import type { CityConfig } from "../city-template/types";

export const gladstoneMOConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Gladstone",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "gladstone-mo",
  route: "/cities/gladstone-mo",
  title: "Emergency Passport Gladstone, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Gladstone, MO — as fast as 24 hours. Serving Clay County and the Northland region. A+ BBB rated registered State Dept. courier serving Gladstone, North Kansas City, and the KC Northland. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Gladstone, MO",
  heroSubtitle: "Northland business trip to London with 4 days to spare? Family reunion in Mexico and your passport expired? Kansas City Northland corporate travel needs fast documents? We help Gladstone residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Gladstone%20Missouri%20Clay%20County%20Northland%20suburban%20Kansas%20City%20metropolitan%20area%20tree%20lined%20residential%20neighborhoods%20North%20Oak%20Trafficway%20corridor%20Linden%20Square%20shopping%20district%20rolling%20green%20hills%20Midwestern%20charm%20golden%20hour%20soft%20light%20professional%20drone%20photography&width=1800&height=700&seq=gladstone-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Gladstone Missouri Clay County Northland suburban landscape at golden hour",
  geoPosition: "39.2200;-94.5580",
  geoPlacename: "Gladstone, Missouri",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 510 miles east of Gladstone via I-35/I-55",
  },
  nearbyCitiesZips: [
    { name: "Gladstone", zips: "64118, 64119" },
    { name: "Kansas City", zips: "64101–64199" },
    { name: "North Kansas City", zips: "64116" },
    { name: "Parkville", zips: "64151, 64152" },
    { name: "Liberty", zips: "64068, 64069" },
    { name: "Riverside", zips: "64150, 64168" },
    { name: "Smithville", zips: "64089" },
    { name: "Kearney", zips: "64060" },
    { name: "Platte City", zips: "64079" },
    { name: "Weatherby Lake", zips: "64152" },
    { name: "Lake Waukomis", zips: "64151" },
    { name: "Pleasant Valley", zips: "64068" },
    { name: "Platte Woods", zips: "64151" },
    { name: "Ferrelview", zips: "64163" },
    { name: "Excelsior Springs", zips: "64024" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Northland departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "KC Northland Hub", desc: "Serving Gladstone, North Kansas City, Parkville, and Clay County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Liberty, MO", route: "/cities/liberty-mo" },
    { name: "Fast passport renewal in Kansas City, MO", route: "/cities/kansas-city" },
    { name: "Emergency passport help in Independence, MO", route: "/cities/independence-mo" },
    { name: "Urgent passport services in St. Joseph, MO", route: "/cities/st-joseph-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Passport courier services in Columbia, MO", route: "/cities/columbia-mo" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Gladstone remotely via secure courier. We do not have a walk-in office in Gladstone — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Clay County and the Kansas City Northland.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Clay County and the KC Northland including Gladstone, North Kansas City, Parkville, Liberty, and surrounding communities",
  serviceAreaIntro: "From the neighborhoods of Gladstone and the North Oak corridor to the historic river town of Parkville and the growing suburbs of Liberty, from the corporate parks of North Kansas City to the lakeside communities of Weatherby Lake and Lake Waukomis — Fast Passport Center serves the entire Kansas City Northland. We regularly help travelers from Gladstone, North Kansas City, and Liberty get their passports fast without the 8-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Gladstone neighborhoods and the surrounding KC Northland area including Kansas City, North Kansas City, Parkville, Liberty, Riverside, Smithville, Kearney, and Platte City. If you are anywhere in Clay County or Platte County, we have you covered.",
  howItWorksIntro: "Most Gladstone travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Gladstone travelers often face an 8-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Gladstone and Northland travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Gladstone? Here are the most common ones we hear from KC Northland travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Gladstone travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Rachel S.",
      location: "Gladstone, MO",
      rating: 5,
      text: "Our family trip to Ireland was in 4 days and my husband realized his passport had expired. Fast Passport Center got his renewal in 29 hours. From North Oak to Dublin in under a week — absolutely incredible service!",
      service: "Passport Renewal",
    },
    {
      name: "Greg P.",
      location: "North Kansas City, MO",
      rating: 5,
      text: "Emergency business trip to Singapore with 5 days notice. Fast Passport Center's dedicated agent handled everything. Daily updates kept me informed the whole way. Best travel document experience I've ever had.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa W.",
      location: "Parkville, MO",
      rating: 5,
      text: "Both kids needed first passports for our Mediterranean cruise. Fast Passport Center walked us through the child process. Got all three new passports in 4 days. Lifesaver for Clay County families!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "gladstone-mo-1",
      name: "Gladstone Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6901 N Oak Trfy",
      city: "Gladstone",
      state: "MO",
      zip: "64118",
      phone: "(816) 436-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Gladstone",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Gladstone facility on North Oak Trafficway. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "gladstone-mo-2",
      name: "Clay County — Administration Building",
      type: "County Government Passport Acceptance",
      address: "1 Courthouse Sq",
      city: "Liberty",
      state: "MO",
      zip: "64068",
      phone: "(816) 407-3550",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "10 miles northeast of Gladstone",
      website: "https://www.claycountymo.gov",
      websiteLabel: "Clay County Recorder",
      notes: "County seat with passport acceptance services. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "gladstone-mo-3",
      name: "North Kansas City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1015 Swift Ave",
      city: "North Kansas City",
      state: "MO",
      zip: "64116",
      phone: "(816) 221-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles south of Gladstone",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves North Kansas City and southern Gladstone area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "gladstone-mo-4",
      name: "Parkville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1900 NW River Park Dr",
      city: "Parkville",
      state: "MO",
      zip: "64152",
      phone: "(816) 741-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles west of Gladstone",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Parkville and Platte County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "gladstone-mo-5",
      name: "Kansas City — Northland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 N Jesse James Rd",
      city: "Kansas City",
      state: "MO",
      zip: "64157",
      phone: "(816) 781-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles northeast of Gladstone",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves KC Northland area near Liberty. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 8 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Gladstone photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Clay County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Gladstone applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Northland families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Gladstone travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Gladstone." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Gladstone address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Gladstone before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Gladstone for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 8-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Gladstone?", a: "Fast Passport Center offers fast passport renewal in Gladstone in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Gladstone?", a: "The nearest regional passport agency to Gladstone is the Chicago Passport Agency, approximately 510 miles east via I-35/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Gladstone without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Gladstone?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 8 hours from Gladstone — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for KC Northland residents." },
    { q: "Do you serve the entire KC Northland area?", a: "Absolutely. Fast Passport Center serves the entire Kansas City Northland including Gladstone, North Kansas City, Parkville, Liberty, and surrounding areas. Our courier service works seamlessly from any address in Clay County or Platte County." },
    { q: "Can I expedite a child passport in Gladstone?", a: "Yes. Fast Passport Center expedites child passports in Gladstone for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Northland families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Gladstone with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Gladstone", address: "7607 N Oak Trfy, Gladstone, MO 64118", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Gladstone", address: "6901 N Oak Trfy, Gladstone, MO 64118", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — North Kansas City", address: "2025 Swift Ave, North Kansas City, MO 64116", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart Supercenter — Liberty", address: "8301 N Church Rd, Kansas City, MO 64158", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Gladstone License Office",
      address: "6013 NE Antioch Rd, Gladstone, MO 64119",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Gladstone residents.",
      featured: true,
    },
    {
      name: "Missouri DOR — North Kansas City License Office",
      address: "1801 Burlington St, North Kansas City, MO 64116",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves NKC and southern Clay County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Liberty License Office",
      address: "18 S Gallatin St, Liberty, MO 64068",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Liberty and eastern Clay County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "20 miles northwest of Gladstone",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international airport with direct flights worldwide. About 25 minutes from Gladstone via I-29.",
      flightUrl: "https://www.flykc.com/",
      flightLabel: "MCI Airport",
      featured: true,
    },
    {
      code: "MKC",
      name: "Charles B. Wheeler Downtown Airport",
      distance: "8 miles south of Gladstone",
      address: "1000 NW Lou Holland Dr, Kansas City, MO 64116",
      note: "General aviation and regional flights. About 15 minutes from Gladstone via US-169.",
      flightUrl: "https://www.flymkc.com/",
      flightLabel: "MKC Airport",
      featured: false,
    },
    {
      code: "STJ",
      name: "Rosecrans Memorial Airport",
      distance: "50 miles north of Gladstone",
      address: "100 NW Rosecrans Rd, St. Joseph, MO 64503",
      note: "Regional airport serving St. Joseph. About 50 minutes from Gladstone via I-29.",
      flightUrl: "https://www.stjoemo.info/airport",
      flightLabel: "STJ Airport",
      featured: false,
    },
  ],
};